import { render, staticRenderFns } from "./viewMob.vue?vue&type=template&id=5592976c&"
import script from "./viewMob.vue?vue&type=script&lang=js&"
export * from "./viewMob.vue?vue&type=script&lang=js&"
import style0 from "./viewMob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QImg,QTooltip,QSeparator,QIcon,QSpace,QPageSticky,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg,QTooltip,QSeparator,QIcon,QSpace,QPageSticky,QBtn})
